import React, { type FC } from 'react';

export const SoldOutIconSvg: FC = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.20711 11.4988L2.20647 10.4994H10.9994V1.70647L11.4988 1.20711L10.7916 0.5L9.79226 1.49939H8.24939V0.99939H7.24939V1.49939H4.74939V0.99939H3.74939V1.49939H0.99939V10.2923L0.5 10.7916L1.20711 11.4988ZM3.74939 2.49939H1.99939V9.29226L8.79226 2.49939H8.24939V2.99939H7.24939V2.49939H4.74939V2.99939H3.74939V2.49939ZM9.99939 9.49939H3.20647L9.99939 2.70647V9.49939Z"
                fill="#918D99"
            />
        </svg>
    );
};
